import { darken } from "@mui/material";
import { createTheme, Theme } from "@mui/material/styles";

declare module "@mui/styles/defaultTheme" {
  interface DefaultTheme extends Theme {}
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#210d4b",
    },
    secondary: {
      main: "#ffff",
      contrastText: "#210d4b",
      light: "#e8e8e8",
    },
    error: {
      main: "#EB5757",
    },
    warning: {
      main: "#FFCA28",
    },
    success: {
      main: "#55bf72",
    },
    info: {
      main: "#a87bff",
      dark: darken("#a87bff", 0.1),
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "#5f6368",
    },
  },
  typography: {
    fontFamily: "Roboto",
    fontSize: 14,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#eaebf0",
        },
      },
    },
  },
});

export default theme;
